import * as Sentry from "@sentry/react";
// import { Integrations } from "@sentry/tracing";

function normalizePath(pathname) {
  const parts = pathname.split("/").filter(part => !!part);
  
  if (parts.length <= 1) {
    return pathname;
  }

  if (["video", "image", "profile"].includes(parts[0])) {
    return `/${parts[0]}/<id>`;
  }

  if (parts[0] === "forum" && parts.length === 1) {
    return "/forum";
  } else if (parts[0] === "forum" && parts.length === 2) {
    return "/forum/<section>";
  } else if (parts[0] === "forum" && parts.length === 3) {
    return "/forum/<section>/<id>";
  }

  return pathname;
}

if (process.env.SENTRY_DSN) {
  console.info("Sentry enabled.");

  const defaultSamplingRate = parseFloat(process.env.SENTRY_TRACE_RATE);

  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    release: `iwara3-pwa@${process.env.VERSION}`,
    environment: process.env.ENVIRONMENT,
    whitelistUrls: [/iwara.tv/],
    ignoreErrors: [
      "Failed to fetch",
      "cancelled",
      "キャンセルしました",
      "Unexpected token < in JSON at position 0",
      "Unexpected end of input",
      /^NotSupportedError:/,
      /^NotAllowedError:/,
      /^AbortError:/,
    ],
    // tracesSampler: samplingContext => {
    //   if (["navigation", "pageload"].includes(samplingContext.transactionContext.op)) {
    //     return 0;
    //   }

    //   return defaultSamplingRate;
    // },
    // integrations: [
    //   new Integrations.BrowserTracing({
    //     tracingOrigins: [
    //       process.env.HOST_API,
    //       process.env.HOST_FILES,
    //     ],
    //     beforeNavigate: context => ({
    //       ...context,
    //       name: normalizePath(location.pathname),
    //     })
    //   })
    // ],
  });
} else {
  console.info("Sentry disabled.");
}

export default Sentry;
